import React, { Component } from "react";
import { HashRouter, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import LoginView from "./views/login/loginView";
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { connect } from "react-redux";
import "./app.css";
import "./dark.scss";
import StatsView from "./views/stats/statsView";
import ProfileView from "./views/profile/profileView";
import QuestionMatch from "./views/questionMatch/questionMatch";
import AnswerMatch from "./views/answerMatch/answerMatch";
import Home from "./views/home";

class App extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { t, i18n } = this.props;
    return (
      <HashRouter>
        <Helmet>
          <title>Kunduz Visio</title>
          <body className={this.props.theme} />
        </Helmet>
        <div className="app">
          <Route exact={true} path="/login" component={LoginView} />
          <Route exact={true} path="/questionMatch" component={QuestionMatch} />
          <Route exact={true} path="/answerMatch" component={AnswerMatch} />

          <Route exact={true} path="/stats" component={StatsView} />
          <Route exact={true} path="/profile" component={ProfileView} />

          <Route exact path="/" component={Home} />
          <ToastContainer autoClose={5000} closeButton={false} />
        </div>
      </HashRouter>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    theme: state.theme
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation("kunduz")(App));
